import { createStore, type StoreActionApi } from 'react-sweet-state';

type State = {
	// curerntly, orgId is optional. Maybe it's a required prop in future.
	orgId?: string;
};
type StoreApi = StoreActionApi<State>;

const actions = {
	setOrgId:
		(orgId?: string) =>
		({ setState }: StoreApi) => {
			setState({
				orgId,
			});
		},
};
type Actions = typeof actions;

const initialState: State = {
	orgId: undefined,
};

/**
 * Manage states of a site
 */
export const Store = createStore<State, Actions>({
	initialState,
	actions,
	name: 'Org',
});
